import React from "react";
import {
  neturalBlack,
  netural400,
  successGreen,
  errorRed,
} from "../../../constants/color";
import { formatId } from "../../../utils/marketplaceHelpers";
import { FaCheckCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

const BusinessInfoCard = ({ business }) => {
  if (!business) return null;

  const CheckIcon = ({ enabled }) => (
    <span style={{ fontSize: "16px" }}>
      {enabled ? (
        <FaCheckCircle color={successGreen} size={18} />
      ) : (
        <MdCancel color={errorRed} size={18} />
      )}
    </span>
  );

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "20px",
        }}
      >
        Business
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div>
          <div
            style={{ color: neturalBlack, fontSize: "16px", fontWeight: "600" }}
          >
            {business.name || "—"}
          </div>
        </div>

        {business.stripeAccountId && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>
              Stripe Account:
            </span>
            <span
              style={{
                color: neturalBlack,
                fontSize: "14px",
                fontFamily: "monospace",
              }}
            >
              {formatId(business.stripeAccountId)}
            </span>
          </div>
        )}

        <div
          style={{
            display: "flex",
            gap: "16px",
            marginTop: "8px",
            fontSize: "14px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ color: netural400 }}>Charges:</span>
            <CheckIcon enabled={business.chargesEnabled} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ color: netural400 }}>Payouts:</span>
            <CheckIcon enabled={business.payoutsEnabled} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{ color: netural400 }}>Verified:</span>
            <CheckIcon enabled={business.sellerVerified} />
          </div>
        </div>

        {business.verificationStatus && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "13px" }}>
              Verification Status:
            </span>
            <span style={{ color: netural400, fontSize: "13px" }}>
              {business.verificationStatus}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BusinessInfoCard;
